import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, SectionTitle } from "../../../ui/index.js";
import { DemoChatPage } from "../../demo-chat/index.js";
import { StepNav } from "../StepNav.js";
import type { StepProps } from "../types.js";

/**
 * Шаг 6: тестовый чат. Владелец пишет боту как клиент (демо-канал: настоящий календарь не трогается).
 * Подсказки «попробуйте спросить»: тестовые диалоги шаблона ниши с тем, что должен сделать бот.
 */
export function TestStep({ state, next, back }: StepProps) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState<string | null>(null);
  const copy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(text);
    } catch {
      setCopied(null);
    }
  };
  return (
    <div>
      <p className="mb-4 text-slate-600">{t("onb.test.intro")}</p>
      {state.testDialogs.length > 0 && (
        <>
          <SectionTitle>{t("onb.test.try")}</SectionTitle>
          <Card className="mb-4 space-y-2">
            {state.testDialogs.map((d) => (
              <button key={d.message} type="button" onClick={() => void copy(d.message)} className="block w-full text-left">
                <span className="block">«{d.message}»</span>
                <span className="block text-xs text-slate-500">
                  {t(`onb.expect.${d.expect}`)}
                  {copied === d.message ? ` · ${t("onb.test.copied")}` : ""}
                </span>
              </button>
            ))}
          </Card>
        </>
      )}
      <DemoChatPage />
      <StepNav onBack={back} onNext={next} />
    </div>
  );
}
